import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import formatStringToNumDate from '../../../../utils/stringManipulation/FormatStringToNumDate';
import isEmpty from '../../../../utils/objectchecking/IsEmpty';

export default function DisplayOptionChoice(props) {
  let optionChoice = {};
  let userOptionChoices = props.optionChoices.choices;
  let availableChains = props.optionChains.chains;
  //console.log(availableChains);
  //console.log(userOptionChoices);
  if (
    userOptionChoices !== undefined &&
    !isEmpty(userOptionChoices) &&
    availableChains !== undefined
  ) {
    let dates = Object.keys(userOptionChoices);
    let symbol = userOptionChoices[dates[0]][0];
    let chainDates = Object.keys(availableChains[0]);
    let chain = availableChains[0][chainDates[0]];
    for (let num in chain) {
      let o = chain[num]; /* JSON.parse(chain[num]); */
      if (o.symbol === symbol) {
        optionChoice = o;
      }
    }
  }
  // console.log(optionChoice);
  return (
    <>
      <Grid item>
        <br />
      </Grid>
      <TextField
        id="optionChoice"
        label="optionChoice"
        style={{
          width: 150,
          height: 50,
        }}
        value={
          optionChoice['option_type'] +
          '-' +
          optionChoice['strike'] +
          '-' +
          optionChoice['expiration_date']
        }
        InputProps={{
          readOnly: true,
          style: {
            fontSize: 10,
          },
        }}
        variant="outlined"
      />
    </>
  );
}
